// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___5z_8","importantInfo":"styles_importantInfo__32_pz"};